import React, { useState } from "react";
import BaseCard from "../../../../../components/ui/BaseCard";
import AddAboutMeModal from "../../../components/AddAboutMeModal";

const AddAboutMe = ({ description, refetchMe }) => {
  const [isAddAboutMeModalOpen, setIsAddAboutMeModalOpen] = useState(false);
  return (
    <>
      <BaseCard className="py-3 px-4 mt-3 border rounded-lg shadow-sm" elevation={0}>
        <div className="bg-light rounded-sm py-2 px-4 mb-4 flex items-center justify-between">
          <p className="text-base font-normal">About Me</p>
          <i
            className="fa-light fa-pencil text-gray-900 cursor-pointer"
            onClick={() => setIsAddAboutMeModalOpen(true)}
          ></i>
        </div>
        <div className="ql-editor !min-h-0 px-4" dangerouslySetInnerHTML={{ __html: description }} />
      </BaseCard>

      <AddAboutMeModal
        open={isAddAboutMeModalOpen}
        close={setIsAddAboutMeModalOpen}
        description={description}
        refetchMe={refetchMe}
      />
    </>
  );
};

export default AddAboutMe;
